import { create } from 'zustand';

type ListFileDownloadState = {
    filesDownloading: ListFileDownloadData[];
    addFileToDownloading: (data: ListFileDownloadData) => void;
    updateFileDownloadState: (updatedData: ListFileDownloadData) => void;
    removeFileFromDownloading: (id: string) => void;
    getFilesDownloading: () => ListFileDownloadData[];
};

export const useListFilesDownloadStore = create<ListFileDownloadState>((set, get) => ({
    filesDownloading: [],
    addFileToDownloading: (data: ListFileDownloadData) => {
        const { filesDownloading } = get();
        set({ filesDownloading: [...filesDownloading, data] });
    },
    updateFileDownloadState: (updatedData: ListFileDownloadData) => {
        const { filesDownloading } = get();
        const fileIndex = filesDownloading.findIndex((item) => item.id === updatedData.id);
        if (fileIndex !== -1) {
            const newArray = [...filesDownloading];
            newArray[fileIndex] = { ...newArray[fileIndex], ...updatedData };
            set({
                filesDownloading: newArray
            });
        }
    },
    removeFileFromDownloading: (id) => {
        const { filesDownloading } = get();
        set({
            filesDownloading: filesDownloading.filter((fileItem) => fileItem.id !== id)
        });
    },
    getFilesDownloading: () => {
        return get().filesDownloading;
    }
}));
